import { useState } from 'react';

type UseViewModelProps = {
  cancelTypes: string[];
  onSubmit: (reason: string) => void;
};

type UseViewModelReturn = {
  reason: string;
  handleReasonTypeChange: (event: React.ChangeEvent<HTMLSelectElement>) => void;
  handleSubmit: () => void;
};

const useViewModel = ({
  cancelTypes,
  onSubmit,
}: UseViewModelProps): UseViewModelReturn => {
  const [reason, setReason] = useState<string>(cancelTypes[0]);

  const handleReasonTypeChange = (
    event: React.ChangeEvent<HTMLSelectElement>
  ): void => {
    setReason(event.target.value);
  };

  const handleSubmit = (): void => {
    onSubmit(reason);
  };

  return {
    reason,
    handleReasonTypeChange,
    handleSubmit,
  };
};

export default useViewModel;
